<div class="setHeightDiv">
  <h5 class="mb-1">Version actuelle : {{ latestVersion }}</h5>
  <div class="d-flex flex-column align-items-start">
    <i-button btnSize="btn-xs" styleClass="green mb-2" id="ReadedButton" (click)="ref.close()"
      text="J'ai bien lu, merci!"></i-button>
  </div>
  @if (versions.length) {
  <i-accordion [hideShowAllBtn]="true">
    @for (version of versions; track version) {
    <i-accordion-tab header="VERSION {{ version }}" [showEditBtn]="false">
      <div class="file__info">
        <a class="file__container" (click)="openVersionInfos(version)">
          <i class="icon bi bi-filetype-pdf"></i>
          <h3 class="file__title">Notes de version {{ version }}</h3>
        </a>
      </div>
    </i-accordion-tab>
    }
  </i-accordion>
  }
</div>